import { authService, dbService } from "fbase";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from '../components/Navigation';
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import useTitle from "@nooks/use-title";
import Orderlist from "components/Orderlist";
// import Orderlog from "components/Orderlog";

const Admin = ({userObj, isLoggedIn}) => {
    useTitle("캐리빌리_ADMIN")
    const navigate = useNavigate();
    const [orderlist, setOrderlist] = useState([]);
    useEffect(()=>{
        const q = query(collection(dbService, "orderlist"), orderBy("reservDate", "desc"));
        onSnapshot(q, (snapshot) => {
            const orderArr = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setOrderlist(orderArr);
        });
        // const logq = query(collection(dbService, "orderlog"), orderBy("createdTime", "desc"));
        // onSnapshot(logq, (snapshot) => {
        //     const orderlogArr = snapshot.docs.map((log) => ({
        //         id: log.id,
        //         ...log.data()
        //     }));
        //     setOrderlog(orderlogArr);
        // })
    }, [])
    const onLogout = () => {
        authService.signOut()
        navigate("/", {replace:true})
    };
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <Orderlist orderlist={orderlist} userObj={userObj} />
            {/* <Orderlog orderlog={orderlog} /> */}
            <section className="page-section" id="admin-btn">
                <div className="container">
                    <div className="row text-center">
                        <div>
                            <Link to={process.env.PUBLIC_URL + `/account/createproduct/`}>
                                <input type="button" className="btn btn-primary btn-xl text-uppercase" value="캐리어 추가하기" />
                            </Link>
                            <input type="button" className="btn btn-primary btn-xl text-uppercase" onClick={onLogout} value="로그아웃" />
                            <br /><br />
                            <h3>입금계좌 : 농협 302-1739-7182-71 장주영</h3>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Admin;